const TEXT_KEYS = {
    TITLE: 'steps-description__title',
    SUBTITLE: 'steps-description__subtitle',
    REWARDS: 'steps-description__rewards',

    STEP_1_TITLE: 'steps-description__step-1__title',
    STEP_1_TEXT: 'steps-description__step-1__text',

    STEP_2_TITLE: 'steps-description__step-2__title',
    STEP_2_TEXT: 'steps-description__step-2__text',

    STEP_3_TITLE: 'steps-description__step-3__title',
    STEP_3_TEXT: 'steps-description__step-3__text',
};

const STEPS_AMOUNT: number = 3;

export default TEXT_KEYS;
export {
    STEPS_AMOUNT
};
